import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Photo} from '../../../../shared/models/cameralla-photo.model';
import {Location} from '@angular/common';
import {PhotoService} from '../../services/photo.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CommentService} from '../../services/comment.service';
import {RatingService} from '../../services/rating.service';
import {ToastrService} from 'ngx-toastr';
import * as $ from 'jquery';

@Component({
    selector: 'app-preview-section',
    templateUrl: './preview-section.component.html',
})
export class PreviewSectionComponent implements OnInit {
    @Input('photoDetails') photoDetails: Photo;
    @Input('photosByUser') photosByUser: Photo[];
    @Input('reviewObject') reviewObject;
    @Input('criterion') criterion: any[];
    @Output() emitGoBack = new EventEmitter<boolean>();

    constructor(private location: Location,
                private photoService: PhotoService,
                private router: Router,
                private route: ActivatedRoute,
                private commentService: CommentService,
                private ratingService: RatingService,
                private toastr: ToastrService) {

    }

    ngOnInit() {
    }

    myRating() {
        let sum = 0;
        this.criterion.forEach(each => sum = sum + each['value']);
        return sum / 6;
    }

    totalStars() {
        let sum = 0;
        this.criterion.forEach(each => sum = sum + each['value']);
        return sum;
    }

    submit() {
        const ratingObj = Object.assign({}, this.reviewObject);

        this.criterion.forEach(each => {
            ratingObj[`${each['name']}`] = each['value'];
        });

        this.ratingService.ratePhoto(ratingObj).toPromise().then(
            response => {
                if (response['IsSuccess']) {
                    this.goBack();
                    this.toastr.success('Photo has been reviewed successfully', 'DONE');
                } else {
                    this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                }
            },
            error => {
                console.log('ratePhoto error ' + error)
                this.toastr.error(error.message, 'FAILED');
            }
        );
    }

    edit() {
        this.emitGoBack.emit(true);
    }

    goBack() {
        this.router.navigate([`/photo/${this.photoDetails.id}`]);
    }

    onScroll() {
        if (!$('<ngb-tooltip-window>').hidden) {
            $('button[aria-describedby]').click();
        }
    }
}
